<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-pen.png" alt width="27.3" height="27.3" />
      <p class="title-bk">法人編集</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'corporation-id-detail', params: { id } }">戻る</router-link>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(confirmEdited)" ref="form">
          <table class="table table-form">
            <tbody>
              <tr>
                <th scope="row">法人ID</th>
                <td />
                <td>{{ currentCorporation.uid }}</td>
              </tr>
              <TextField
                v-model="currentCorporation.name"
                label="法人名"
                placeholder="全角カタカナ"
                extraRules="required"
              />
              <TextField
                v-model="currentCorporation.nameReading"
                label="法人名（フリガナ）"
                placeholder="全角カタカナ"
                extraRules="required"
              />
              <PostalCodeField
                v-model="currentCorporation.postalCode"
                @fillAddresses="fillAddresses($event)"
                extraRules="required"
                inputClass="col-lg-4"
              />
              <TextField
                v-model="currentCorporation.state"
                label="都道府県 市区町村"
                placeholder="例）京都府京都市中京区笋町"
                extraRules="required"
              />
              <TextField
                v-model="currentCorporation.address"
                label="番地・建物名"
                placeholder="例）688 第15長谷ビル5F"
                extraRules="required"
              />
              <TextField
                v-model="currentCorporation.phone"
                extraRules="phone_number|required"
                label="電話番号"
                placeholder="例）075-708-8100"
              />

              <TextField
                v-model="currentCorporation.fax"
                extraRules="phone_number"
                label="FAX番号"
                placeholder="例）075-708-8101"
              />
              <TextField
                v-model="currentCorporation.email"
                extraRules="email"
                label="メールアドレス"
                placeholder="例）sample@tamaishiki.com"
              />
              <ProductField
                v-model="currentCorporation.figuredProducts"
                :options="product.products"
                :errorText="errorText"
              />
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-confirm">確認</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import { ValidationObserver } from 'vee-validate';
import TextField from '@/components/forms/TextField.vue';
import PostalCodeField from '@/components/forms/PostalCodeField.vue';
import ProductField from '@/components/forms/ProductField.vue';
import map from 'lodash/map';
import difference from 'lodash/difference';

export default {
  data() {
    return {
      errorText: '',
    };
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    ValidationObserver,
    TextField,
    PostalCodeField,
    ProductField,
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('corporation/fetchCorporation', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  async created() {
    await this.fetchProducts();
    await this.fetchSchoolsOfCorporation(this.currentCorporation.id);
  },
  computed: {
    currentCorporation() {
      if (this.corporation.editingCorporation) {
        return this.corporation.editingCorporation;
      } else {
        return this.corporation.corporation;
      }
    },
    ...mapState(['corporation']),
    ...mapState(['school']),
    ...mapState(['product']),
  },
  methods: {
    fillAddresses(addressComponents) {
      this.$logger.debug('addressComponents', addressComponents);
      this.currentCorporation.state = addressComponents.city_state;
      this.currentCorporation.address = addressComponents.address;
    },
    isRemovingProductUsedBySchool() {
      // 教場で利用教材が設定されている状態で、法人の利用教材を外そうとした場合はエラーとする
      const corporationProducts = this.currentCorporation.figuredProducts;
      const corporationProductCodes = map(corporationProducts, (product) => product.code);

      for (const school of this.school.schools) {
        const schoolProductCodes = map(school.figuredProducts, (schoolProduct) => schoolProduct.code);
        const diffProductCodes = difference(schoolProductCodes, corporationProductCodes);
        if (diffProductCodes.length > 0) return true;
      }
      return false;
    },
    confirmEdited() {
      this.$logger.debug('Started Editing: ' + JSON.stringify(this.currentCorporation));
      if (this.isRemovingProductUsedBySchool()) {
        this.errorText = '教場の利用教材と一致しないため、変更できません。教場の利用教材を確認してください。';
        return;
      }
      this.startEditingCorporation(this.currentCorporation);
      this.$router.push({ name: 'corporation-id-confirm', params: { id: this.id } });
    },
    ...mapActions('corporation', ['startEditingCorporation']),
    ...mapActions('school', ['fetchSchoolsOfCorporation']),
    ...mapActions('product', ['fetchProducts']),
  },
};
</script>

<style scoped>
.btn-confirm {
  margin-left: 0px;
}
</style>
